import { render, staticRenderFns } from "./RbuItemEditor.vue?vue&type=template&id=1df9d0eb"
import script from "./RbuItemEditor.vue?vue&type=script&lang=js"
export * from "./RbuItemEditor.vue?vue&type=script&lang=js"
import style0 from "./RbuItemEditor.vue?vue&type=style&index=0&id=1df9d0eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports